import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Oneworld = function Oneworld(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Oneworld_svg__Oneworld_svg__clip0_4391_8803)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#Oneworld_svg__Oneworld_svg__paint0_linear_4391_8803)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Oneworld_svg__Oneworld_svg__filter0_f_4391_8803)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17,
    fill: "#fff",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Oneworld_svg__a",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0A20 20 0 110 20 20.038 20.038 0 0120 0z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Oneworld_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Oneworld_svg__Oneworld_svg__filter1_f_4391_8803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.476 11.921c-2.568 1.483-8.883 2.513-10.28.093-1.397-2.42 2.652-7.374 5.22-8.856 2.568-1.483 9.657-2.96 11.054-.54 1.397 2.42-3.427 7.82-5.994 9.303z",
    fill: "#fff",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Oneworld_svg__Oneworld_svg__filter2_f_4391_8803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.648 10.882c-2.511 1.45-8.564 2.669-9.78.563-1.216-2.106 2.866-6.739 5.377-8.189 2.512-1.45 9.323-3.106 10.539-1C22 4.362 17.16 9.432 14.648 10.882z",
    fill: "#fff",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Oneworld_svg__Oneworld_svg__filter3_f_4391_8803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.29 7.826C8.873 9.22 3.327 10.87 2.5 9.436c-.83-1.435 3.374-5.412 5.79-6.807C10.704 1.235 16.98-.837 17.807.6c.828 1.434-4.103 5.832-6.519 7.227z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.26 16.6v6.094h.381v-6.095h-.381z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.872 21.414c-.113.392-.412.446-.793.446-.83 0-.986-.638-.995-1.064h3.327v-.245c-.018-.54-.132-2.453-2.281-2.453-1.445 0-2.482.834-2.482 2.366 0 2.257 1.795 2.388 2.377 2.388.819 0 1.951-.194 2.3-1.447l-1.453.009zm-1.784-1.338c.025-.446.237-1.037 1.02-1.037.323 0 .813.087.83 1.037h-1.85z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.414 18.272H8.74v.528a1.96 1.96 0 011.603-.695c.627 0 1.546.165 1.546 1.81v2.779h-1.385v-2.357c0-.435-.047-1.14-.783-1.14-.907 0-.925 1.02-.925 1.211v2.286h-1.38v-4.422z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.674 20.473c0 1.627-1.046 2.388-2.422 2.388-1.373 0-2.419-.76-2.419-2.388 0-1.74 1.184-2.366 2.42-2.366 1.39 0 2.421.738 2.421 2.366zm-3.358.006c0 .504.094 1.338.936 1.338.861 0 .94-.838.94-1.338 0-1.275-.672-1.338-.94-1.338-.267 0-.936.072-.936 1.338z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.982 22.694l-1.18-3.97-1.177 3.97h-.52l-1.364-4.422h.428l1.207 3.96 1.186-3.96h.484l1.186 3.96 1.207-3.96h.428l-1.365 4.422h-.52z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.324 20.482c0 1.315.593 2.388 2.076 2.388s2.076-1.073 2.076-2.388c0-1.316-.593-2.384-2.076-2.384s-2.076 1.07-2.076 2.384zm.408 0c0-1.253.54-2.08 1.668-2.08s1.668.826 1.668 2.08c0 1.253-.54 2.08-1.668 2.08s-1.668-.825-1.668-2.08z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.328 18.185h.205v.392h-.196c-.58.023-1.543.223-1.543 2.007v2.11H29.4v-4.422h.393v.914h.018a1.607 1.607 0 011.516-1.001z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.119 19.023V16.6h.404v6.1h-.4v-.706h-.017c-.078.186-.422.893-1.561.893-1.894 0-1.974-1.965-1.974-2.453 0-1.655.906-2.324 1.956-2.324a1.71 1.71 0 011.592.914zm-1.603-.617c-1.14 0-1.519 1.066-1.519 2.007v.004c0 2.063 1.193 2.15 1.539 2.15.778 0 1.61-.556 1.61-2.054 0-1.289-.607-2.107-1.63-2.107z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Oneworld_svg__Oneworld_svg__filter0_f_4391_8803",
    x: -17,
    y: -17,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_4391_8803"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Oneworld_svg__Oneworld_svg__filter1_f_4391_8803",
    x: -7.089,
    y: -10.666,
    width: 40.808,
    height: 36.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4391_8803"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Oneworld_svg__Oneworld_svg__filter2_f_4391_8803",
    x: -7.353,
    y: -10.743,
    width: 40.33,
    height: 35.319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_4391_8803"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Oneworld_svg__Oneworld_svg__filter3_f_4391_8803",
    x: -4.607,
    y: -6.887,
    width: 29.507,
    height: 23.876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_4391_8803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oneworld_svg__Oneworld_svg__paint0_linear_4391_8803",
    x1: 7,
    y1: 4,
    x2: 33.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7782BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35459C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Oneworld_svg__Oneworld_svg__clip0_4391_8803"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
export default Oneworld;